import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

type StyleProps = {
  type?: "error" | "alert" | "success" | "warning" | "info";
  width?: string;
  maxWidth?: string;
};

export const Wrapper = styled("div")({
  width: "100%",
  position: "relative",
});

export const TimeControlHeader = styled("header")({
  display: "flex",
  justifyContent: "space-between",
});

export const TimeControlTitle = styled("span")({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: 0.15,
  color: colors.gray700,
});

export const FieldWrapper = styled("div")({
  display: "flex",
  alignItems: "bottom",
  gap: 24,
  flexWrap: "nowrap",
  width: "100%",
  marginTop: 8,
  "& div": {
    width: "100%",
  },
});

export const Field = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 10,
});

export const FieldLabel = styled("span")({
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: 0.1,
  color: colors.gray600,
});

export const FieldValue = styled("span")({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: 0.1,
  color: colors.gray600,
});

export const Divider = styled("div")({
  width: "100%",
  height: 1,
  backgroundColor: colors.gray200,
  marginTop: "24px",
  marginBottom: "12px",
});

export const BoxForm = styled("div")({
  padding: "16px 0 16px 16px",
  border: `1px solid ${colors.gray200}`,
  width: "100%",
  borderRadius: 8,
  margin: 12,
  "& > div": {
    width: "100% !important",
  },
});

export const FormHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: 12,
  width: "100%",
});

export const FormHeaderTitle = styled("span")({
  color: colors.gray700,
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: 16,
  lineHeight: "24px",
  letterSpacing: 0.15,
});

export const FormHeaderRight = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 12,
});

export const CostBoxTitle = styled("span")({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: 16,
  lineHeight: "24px",
  letterSpacing: 0.5,
  color: colors.gray600,
});

export const CostBoxPrice = styled("span")({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: 16,
  lineHeight: "24px",
  letterSpacing: 0.5,
  color: colors.brandBlue600,
});

const styles = makeStyles(() => ({
  mainDialog: {
    width: (props: StyleProps) => {
      return `${props?.width || "50%"} !important`;
    },
    maxWidth: (props: StyleProps) => {
      return props?.maxWidth || "auto";
    },
    "@media (max-width: 1200px)": {
      width: "50%",
    },
    "@media (max-width: 900px)": {
      width: "60%",
    },
    "@media (max-width: 600px)": {
      width: "90% !important",
    },
  },
}));

export default styles;
